import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { IAPPlannerResourceTab } from './../builders/planner_resource_tab_builder';
import { PlannerResourceMAPTab } from './../constants/planner_resource_tabs';
export type APSelectedPlannerResourceTab = ITypedModel<IAPPlannerResourceTab>;

angular
  .module('capability-ng-academic-planner')
  .factory('ngAPSelectedPlannerResourceTab', (): APSelectedPlannerResourceTab => {
    return new Model<IAPPlannerResourceTab>(PlannerResourceMAPTab);
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_resources/models/selected_planner_resource_tab_model.ts